export const ACTIVATE_SCALE_UP = 'ACTIVATE_SCALE_UP'
export const DEACTIVATE_SCALE_UP = 'DEACTIVATE_SCALE_UP'
